export function formatTimeFromNumber(time: string) {
  const str = time.padStart(6, "0");
  const hours = str.substring(0, 2);
  const minutes = str.substring(2, 4);
  const seconds = str.substring(4, 6);

  return `${hours}:${minutes}:${seconds}`;
}

export function formatDateFromNumbers(date: string) {
  if (!date.length) {
    const today = new Date();
    return today.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  }
  const year = parseInt(date.substring(0, 4));
  const month = parseInt(date.substring(4, 6)) - 1;
  const day = parseInt(date.substring(6, 8));

  const formattedDate = new Date(year, month, day);
  return formattedDate.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}


export function getCurrentDateString(): string {
  const date = new Date();
  const year = date.getUTCFullYear();
  const month = (date.getUTCMonth() + 1).toString().padStart(2, "0");
  const day = date.getUTCDate().toString().padStart(2, "0");
  return `${year}${month}${day}`;
}


export function getLocalCurrentDateString() {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return `${year}${month}${day}`;
}

export function parseTimestampToUTC(
  dateString: string,
  timeString: string
): Date {
  if (!dateString || !timeString) {
    return new Date();
  }
  const year = parseInt(dateString.substring(0, 4));
  const month = parseInt(dateString.substring(4, 6)) - 1;
  const day = parseInt(dateString.substring(6, 8));

  const hours = parseInt(timeString.substring(0, 2));
  const minutes = parseInt(timeString.substring(2, 4));
  const seconds = parseInt(timeString.substring(4, 6));

  return new Date(Date.UTC(year, month, day, hours, minutes, seconds));
}

// Convert numeric date (YYYYMMDD) and time (HHMMSS) to GMT Date object
export function convertNumberToGMTDate(date: string, time: string): Date {
  const year = parseInt(date.substring(0, 4));
  const month = parseInt(date.substring(4, 6)) - 1; // JS months are 0-based
  const day = parseInt(date.substring(6, 8));
  
  const timeStr = time.padStart(6, "0");
  const hours = parseInt(timeStr.substring(0, 2));
  const minutes = parseInt(timeStr.substring(2, 4));
  const seconds = parseInt(timeStr.substring(4, 6));
  
  return new Date(Date.UTC(year, month, day, hours, minutes, seconds));
}

// Format the GMT date to local date string (e.g., "Jun 18, 2025")
export function formatDateFromGMT(gmtDate: Date): string {
  return gmtDate.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}

// Format the GMT date to local time string (e.g., "03:03:32")
export function formatTimeFromGMT(gmtDate: Date): string {
  return gmtDate.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false
  });
}
